import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
    campo: {
        width: '200px',
    },
});

export default useStyles;
